// Use this code snippet in your app.
// If you need more information about configurations or implementing the sample code, visit the AWS docs:
// https://aws.amazon.com/developers/getting-started/nodejs/
// Load the AWS SDK
import config from '../../environmentConfig.json'
import AWS from 'aws-sdk'
import store from '../../store'

const STAGE = (process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'dev') ? 'development' : process.env.NODE_ENV
const region = config[STAGE].cognito.Region
const idp = config[STAGE].cognitoIdp.IdentityPoolId
const upid = config[STAGE].cognito.UserPoolId
const LOGINS = {}
LOGINS[`cognito-idp.${region}.amazonaws.com/${upid}`] = store.state.user.idToken
AWS.config.region = region
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: idp,
  Logins: LOGINS,
})
// Create a Secrets Manager client
var client = new AWS.SecretsManager({
  region: region,
})

// In this sample we only handle the specific exceptions for the 'GetSecretValue' API.
// See https://docs.aws.amazon.com/secretsmanager/latest/apireference/API_GetSecretValue.html
// We rethrow the exception by default.

export async function retrieveSecretCybersource() {
  return new Promise((resolve, reject) => {
    client.getSecretValue({ SecretId: config[STAGE].secureAcceptanceSecret }, function (err, data) {
      if (err) {
        if (err.code === 'DecryptionFailureException') {
          reject(err)
        } else if (err.code === 'InternalServiceErrorException') {
          reject(err)
        } else if (err.code === 'InvalidParameterException') {
          reject(err)
        } else if (err.code === 'InvalidRequestException') {
          reject(err)
        } else if (err.code === 'ResourceNotFoundException') {
          reject(err)
        } else {
          reject(err)
        }
      } else {
        resolve(data.SecretString)
      }
    })
  })
}
